import { Navigate } from 'react-router-dom';

export default function WebsiteMediaAdmin() {
  return <Navigate to="/admin/website-content" replace />;
}
